import React from "react";
import { Link } from "react-router-dom";
import { History } from "history";

import { Box, CampoEstatico, TipoCampoEstatico, Alerta, TipoAlerta, Botao } from "@intechprev/componentes-web";
import { EmprestimoDetalhe } from "./EmprestimoDetalhe";
import { SimuladorEmprestimo } from "./Simulador";
import { SimuladorEmprestimoPrestacoes } from "./Simulador/Prestacoes";
import { SimuladorEmprestimoResumo } from "./Simulador/Resumo";
import { SimuladorEmprestimoContratacao } from "./Simulador/Contratacao";

import { EmprestimoService } from "../../services";
import { ContratoEntidade } from "../../entidades";

import { MasterPage, NumFuncionalidade } from "../MasterPage";
import { reCAPTCHA } from "../../helpers";

export { EmprestimoDetalhe, SimuladorEmprestimo, SimuladorEmprestimoPrestacoes, SimuladorEmprestimoResumo, SimuladorEmprestimoContratacao };

interface Props {
  history?: History;
}

interface State {
  emprestimos: Array<ContratoEntidade>;
}

export class Emprestimos extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("emprestimos");

  private page = React.createRef<MasterPage>();

  constructor(props: Props) {
    super(props);

    this.state = {
      emprestimos: [],
    };
  }

  componentDidMount = async () => {
    try {
      await this.page.current.alternarLoading();

      const emprestimos = await EmprestimoService.Buscar();

      await this.setState({ emprestimos });

      await this.page.current.alternarLoading();
    } catch (err) {
      console.log(err);
    }
  };

  montarLink = (numero: any, ano: any) => {
    return `emprestimodetalhe/${numero}/${ano}`;
  };

  condicaoCarregarEmprestimos = () => {
    return this.state.emprestimos.length > 0;
  };

  renderEmprestimosInfo = () => {
    const ref_cor: { [index: string]: string } = {
      "1": "warning",
      "2": "warning",
      "3": "success",
      "5": "danger",
    };

    const tempInfo = this.state.emprestimos.map((info: any, index: number) => {
      return (
        <tr key={index}>
          <td>
            <i className={`mr-2 fas fa-circle text-${ref_cor[info.CD_SITUACAO]}`}></i>
            {info.DS_SITUACAO}
          </td>
          <td>{`${info.NUM_CONTRATO}/${info.ANO_CONTRATO}`}</td>
          <td>{info.DT_SOLICITACAO}</td>
          <td>{info.DT_CREDITO}</td>
          <td>
            <CampoEstatico valor={info.VL_SOLICITADO} tipo={TipoCampoEstatico.dinheiro} />
          </td>
          <td>
            <CampoEstatico valor={info.VL_PRESTACAO} tipo={TipoCampoEstatico.dinheiro} />
          </td>
          <td>
            <CampoEstatico valor={info.VL_LIQUIDO} tipo={TipoCampoEstatico.dinheiro} />
          </td>
          <td>{info.PRAZO}</td>
          <td>
            <Link className={"text-primary"} to={this.montarLink(info.NUM_CONTRATO, info.ANO_CONTRATO)}>
              Detalhar
            </Link>
          </td>
        </tr>
      );
    });

    return (
      <table className={"table table-responsive"}>
        <thead>
          <tr>
            <th>Situação</th>
            <th>Nº/Ano</th>
            <th>Solicitação</th>
            <th>Crédito</th>
            <th>Valor Solicitado</th>
            <th>Valor Prestação</th>
            <th>Valor Líquido</th>
            <th>Prazo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{tempInfo}</tbody>
      </table>
    );
  };

  renderComEmprestimos = () => {
    return (
      <Box titulo={"Empréstimos Concedidos"}>
        {this.renderEmprestimosInfo()}
        {this.state.emprestimos.filter((x) => x.CD_SITUACAO === 0).length > 0 && (
          <Alerta
            tipo={TipoAlerta.info}
            mensagem={
              "Para cancelar o empréstimo com situação em <b>SIMULAÇÃO</b>, é necessário solicitar por e-mail <b>seguridade@previrb.com.br</b>, colocando no assunto Cancelamento do Empréstimo e o número da sua matrícula, até o dia 20 do mês do crédito do empréstimo."
            }
          />
        )}
      </Box>
    );
  };

  renderSemEmprestimos = () => {
    return <Alerta mensagem={"Você não possui nenhum empréstimo concedido com a PREVIRB."} tipo={TipoAlerta.danger} />;
  };

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.EMPRESTIMOS_CONSULTA} {...this.props} ref={this.page}>
        <Botao className={"m-3"} onClick={() => this.props.history.push("/simuladorEmprestimo")} titulo={"Requerer Novo Empréstimo"} />

        <Botao className={"m-3"} titulo={"Informe para Fins de IR"} onClick={() => this.props.history.push("/emprestimosInforme")} />

        {this.condicaoCarregarEmprestimos() ? this.renderComEmprestimos() : this.renderSemEmprestimos()}
      </MasterPage>
    );
  }
}
